import { getFetch, postFetch } from "@/plugins/http";

const baseHost = `${process.env.VUE_APP_HOST}`;
const commonApiBaseUrl = `${baseHost}/hike-boot/common/api`;
const zhsTeachingHost = '//fteaching.zhihuishu.com'
const zhsLibraryHost = '//hike-shared-library.zhihuishu.com'
const zhsEnlistHost= '//shiepedu.zhihuishu.com'

export default {
    // 培训类型
    getTrainType(params) {
        return getFetch(`${commonApiBaseUrl}/33-queryTrainingTypeList/training_home_page`, params);
    },
    // 培训状态
    getTrainSetting(params) {
        return getFetch(`${commonApiBaseUrl}/33-getTrainingSetting/training_home_page`, params);
    },
    // 培训列表
    getTrainPageList(params) {
        return getFetch(`${commonApiBaseUrl}/34-queryTrainingTermPageList/training_home_page`, params);
    },
    // 培训项目-运行模式
    getOperationModel(params) {
        return getFetch(`${commonApiBaseUrl}/32-getOperationModel/training_home_page`, params);
    },
    // 培训项目-项目详情
    getTrainingInfo(params) {
        return getFetch(`${commonApiBaseUrl}/32-px_training_info/training_home_page`, params);
    },
    // 培训项目_项目栏目
    getTrainingColumns(params) {
        return getFetch(`${commonApiBaseUrl}/33-px_training_columns/training_home_page`, params);
    },
    // 培训项目_报名状态
    getApplyStatus(params) {
        return getFetch(`${commonApiBaseUrl}/32-getApplyStatus/training_home_page`, params);
    },
    // 获取学期报名表单信息
    getTermFormInfo(params) {
        return getFetch(`${baseHost}/hike-boot/trainingTermApply/getTermFormInfo`, params);
    },
    // 发送短信验证码
    sendSmsCode(params = {}, config) {
        return postFetch(`${baseHost}/hike-boot/api/basicSendSms/sendSmsCode`, params, config)
    },
    // 验证码验证
    validateCode(params = {}, config) {
        return postFetch(`${baseHost}/hike-boot/api/basicSendSms/validateCode`, params, config)
    },
    saveApply(params = {}, config) {
        return postFetch(`${baseHost}/hike-boot/trainingTermApply/saveApply`, params,{
            headers: {
              'Content-Type': 'application/json'
            }
        })
    },
    getAgainApplyUserInfo(params) {
        return getFetch(`${baseHost}/hike-boot/trainingTermApply/getAgainApplyUserInfo`, params);
    },
    // 门户-报名须知-查询
    getTrainNoticeInfo(params) {
        return getFetch(`${baseHost}/hike-boot/common/api/32-getEnroll/training_home_page`, params);
    },
}